import { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import useEnergyBattery from '../../hooks/useEnergyBatt';
import { AppChartCard } from '../@dashboard/app';
import { getUnitForEnergy } from '../../utils/apiCommonMethods';

const minHeightStyle = { minHeight: 320 };

export default function EnergyChart({
  site,
  startDate,
  endDate,
  msSessionInfo,
  expandContractChart,
  refreshKey,
}) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  const { loading, series, domainStartMs, domainEndMs } = useEnergyBattery({
    site,
    startDate,
    endDate,
    msSessionInfo,
    inView,
    refreshKey,
  });

  const hasData = useMemo(() => {
    if (!series || series.length === 0) return false;
    const s0 = series[0]?.data?.length ?? 0;
    const s1 = series[1]?.data?.length ?? 0;
    return s0 > 0 || s1 > 0;
  }, [series]);

  if (!inView) {
    return <div ref={ref} style={minHeightStyle} />;
  }

  if (loading) {
    return (
      <div
        ref={ref}
        style={{ ...minHeightStyle, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress />
      </div>
    );
  }


  if (!hasData) {
    return <div ref={ref} style={minHeightStyle} />; 
  }


  return (
    <div ref={ref}>
      <AppChartCard
        title="Energy Available"
        subheader={`Energy ${getUnitForEnergy(site?.id)}`}
        xAxisLabel="Hour Beginning"
        expandContractChart={expandContractChart}
        chartData={series}
        xMinMs={domainStartMs}
        xMaxMs={domainEndMs}
      />
    </div>
  );
}

EnergyChart.propTypes = {
  site: PropTypes.object,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  msSessionInfo: PropTypes.object,
  expandContractChart: PropTypes.func,
  refreshKey: PropTypes.number,
};
